export const HOME_BANNERS_SERVICE_URL = '/ru/_/service/isnareactcms/home-banners';

export const HOME_BANNERS_ROUTES = {
    list: '/arm/pages/home-banners',
    create: '/arm/pages/home-banners/create',
    edit: '/arm/pages/home-banners/edit',
} as const;

export const HOME_BANNER_DATE_FORMAT = 'DD.MM.YYYY';
export const HOME_BANNER_DATE_TIME_FORMAT = 'DD.MM.YYYY HH:mm';
export const HOME_BANNER_REQUEST_DATE_FORMAT = 'YYYY-MM-DD';

export const HOME_BANNER_IMAGE_PARENT = '/isna-portal-cms/images';
export const HOME_BANNER_IMAGE_UPLOAD_URL = '/admin/rest-v2/cs/cms/ru/content/content/createMedia';
export const HOME_BANNER_IMAGE_ACCEPT = 'image/jpeg,image/png,image/webp';
export const HOME_BANNER_IMAGE_ACCEPTED_TYPES = HOME_BANNER_IMAGE_ACCEPT.split(',');

export const getHomeBannerIconUrl = (id: string) =>
    `/admin/rest-v2/cs/cms/ru/content/content/icon/${id}`;

export const getHomeBannerEditUrl = (id: string) => `${HOME_BANNERS_ROUTES.edit}?id=${id}`;
